import React from "react";
import { Modal, ModalHeader, ModalBody, ModalFooter } from "reactstrap";
import Axios from "axios";
import { apiUri } from "../../config";
import { withRouter } from "react-router-dom";

const SubscriptionExpirationAlert = ({
  showSubscriptionAlert,
  updateSubscriptionStatus,
  history,
}) => {
  const handleContactUs = () => {
    //updateSubscriptionStatus();
    window.open("https://www.sarlit.com/contact-us", "_blank");					
  };

  const handleSubscribeButtonClick = () => {
    const token = localStorage.getItem("keycloak_token");

    const config = {
      headers: { Authorization: "Bearer " + token },
    };

    Axios.get(`${apiUri}/cases/getUserId`, config)
      .then((response) => {
        if (
          response.status === 200 &&
          response.data &&
          response.data.content &&
          response.data.content.userExisted
        ) {
          updateSubscriptionStatus();
          history.push({
            pathname: "/addCompany",
            state: {
              user: { registrationUuid: response.data.content.registrationId },
            },
          });
        }
      })
      .catch((error) => {
        console.log("error", error);
      });
  };
  return (
    <Modal
      isOpen={showSubscriptionAlert}
      className="warning-model"
      backdrop="static"
    >
      <ModalHeader>SAR ACE Alert Subscription Expired</ModalHeader>
      <ModalBody>
        Thank you for subscribing to SAR's Free ACE Alert system. You have
        received your first alert and your subscription is now expired. To
        continue receiving alerts, please subscribe to our ACE Alerts or contact
        our sales team directly at 202-436-9994 or e-mail us at info@sarlit.com.
      </ModalBody>
      <ModalFooter>
        <button className="sar-btn close-btn" onClick={handleContactUs}>
          Contact Us
        </button>
        <button
          className="sar-btn close-btn"
          onClick={handleSubscribeButtonClick}
        >
          Subscribe
        </button>
      </ModalFooter>
    </Modal>
  );
};

export default withRouter(SubscriptionExpirationAlert);



// WEBPACK FOOTER //
// ./src/common/components/SubscriptionExpirationAlert.js